import React from "react";
import { Container, Row, Image, Col } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y, Pagination } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const SectionSeven = () => {
  return (
    <>
      <Container fluid>
        <Container>
          <div className="pt-7">
            <h2 className="colorGreen text-4xl font-extrabold">
              Valuable Reviews
            </h2>
          </div>
          <Container>
            <Row>
              <Swiper
                id="mm1"
                // install Swiper modules
                modules={[Navigation, A11y, Pagination]}
                spaceBetween={50}
                slidesPerView={2}
                loop={true}
                navigation
                pagination={{ clickable: true }}
                // scrollbar={{ draggable: true }}
                onSwiper={(swiper) => console.log(swiper)}
                onSlideChange={() => console.log("slide change")}
                breakpoints={{
                  "@0.00": {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  "@0.75": {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  "@1.00": {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  "@1.50": {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                }}
              >
                <SwiperSlide>
                  <div
                    className="border-black rounded-md webkit p-5"
                    style={{ background: "#1E1E1E" }}
                  >
                    <div>
                      <Image
                        className="w-2/6"
                        src={require("../../assets/comaas.png")}
                      />
                      <p className="text-white text-sm font-semibold py-2">
                        Everything worked out wonderful. We had read about this
                        company on a forum. The car was delivered to the hotel
                        on time and the price is fair. We received a friendly
                        briefing and the car itself was in perfect condition. We
                        rented it on Mauritius. Any time again.
                      </p>
                    </div>
                    <div className="webkit py-3">
                      <div className="d-flex flex-row gap-3 align-items-center justify-center">
                        <div className="w-14 h-14 rounded-full">
                          <Image src={require("../../assets/client.png")} />
                        </div>
                        <div className="text-left">
                          <h2 className="text-white text-lg font-bold">
                            Hamza Sheikh
                          </h2>
                          <p className="text-sm colorGreen font-medium">
                            Accountant
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="border-black rounded-md webkit p-5"
                    style={{ background: "#1E1E1E" }}
                  >
                    <div>
                      <Image
                        className="w-2/6"
                        src={require("../../assets/comaas.png")}
                      />
                      <p className="text-white text-sm font-semibold py-2">
                        Everything worked out wonderful. We had read about this
                        company on a forum. The car was delivered to the hotel
                        on time and the price is fair. We received a friendly
                        briefing and the car itself was in perfect condition. We
                        rented it on Mauritius. Any time again.
                      </p>
                    </div>
                    <div className="webkit py-3">
                      <div className="d-flex flex-row gap-3 align-items-center justify-center">
                        <div className="w-14 h-14 rounded-full">
                          <Image src={require("../../assets/client.png")} />
                        </div>
                        <div className="text-left">
                          <h2 className="text-white text-lg font-bold">
                            Hamza Sheikh
                          </h2>
                          <p className="text-sm colorGreen font-medium">
                            Accountant
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="border-black rounded-md webkit p-5"
                    style={{ background: "#1E1E1E" }}
                  >
                    <div>
                      <Image
                        className="w-2/6"
                        src={require("../../assets/comaas.png")}
                      />
                      <p className="text-white text-sm font-semibold py-2">
                        Everything worked out wonderful. We had read about this
                        company on a forum. The car was delivered to the hotel
                        on time and the price is fair. We received a friendly
                        briefing and the car itself was in perfect condition. We
                        rented it on Mauritius. Any time again.
                      </p>
                    </div>
                    <div className="webkit py-3">
                      <div className="d-flex flex-row gap-3 align-items-center justify-center">
                        <div className="w-14 h-14 rounded-full">
                          <Image src={require("../../assets/client.png")} />
                        </div>
                        <div className="text-left">
                          <h2 className="text-white text-lg font-bold">
                            Hamza Sheikh
                          </h2>
                          <p className="text-sm colorGreen font-medium">
                            Accountant
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div
                    className="border-black rounded-md webkit p-5"
                    style={{ background: "#1E1E1E" }}
                  >
                    <div>
                      <Image
                        className="w-2/6"
                        src={require("../../assets/comaas.png")}
                      />
                      <p className="text-white text-sm font-semibold py-2">
                        Everything worked out wonderful. We had read about this
                        company on a forum. The car was delivered to the hotel
                        on time and the price is fair. We received a friendly
                        briefing and the car itself was in perfect condition. We
                        rented it on Mauritius. Any time again.
                      </p>
                    </div>
                    <div className="webkit py-3">
                      <div className="d-flex flex-row gap-3 align-items-center justify-center">
                        <div className="w-14 h-14 rounded-full">
                          <Image src={require("../../assets/client.png")} />
                        </div>
                        <div className="text-left">
                          <h2 className="text-white text-lg font-bold">
                            Hamza Sheikh
                          </h2>
                          <p className="text-sm colorGreen font-medium">
                            Accountant
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </Row>
          </Container>
        </Container>
      </Container>
    </>
  );
};
